import { useEffect, useState } from 'react';
import http, { setConfig } from '../services/http';
import { setToken, setExpirationDate } from '../services/user';
import { endPoints } from '../utils/constanst';

const useToken = (loginUri) => {

    const [loading, setLoading] = useState(true);

    const login = async uri => {

      
        let localData = localStorage.getItem('config')
        if (localData !== undefined || localData !== null)
            await setConfig();



        const data = await http(uri ?? endPoints.auth.login).postOutWithAuth();

        setToken(data.token);
        setExpirationDate(data.expires)
        setLoading(false);

    };

    useEffect(() => {

        login(loginUri);

    }, [0]);


    return {
        loading,
        login
    }
}

export default useToken;
